import React from 'react';
import styled from 'styled-components';
import { formatPct, periodText } from '../reportModel';

const Band = styled.div`
  background: ${({ theme }) => theme.colors.report.brand};
  color: ${({ theme }) => theme.colors.report.paper};
  border-radius: 8px 8px 0 0;
  padding: 24px 32px 20px;
  font-family: ${({ theme }) => theme.metrics.font.family};
`;

const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
`;

const Pill = styled.span`
  border: 1px solid ${({ theme }) => theme.colors.report.paper};
  border-radius: 999px;
  padding: 4px 12px;
`;

const Title = styled.h1`
  margin: 16px 0 4px;
  font-size: 30px;
  font-weight: 800;
`;

const Accent = styled.div`
  width: 72px;
  height: 4px;
  margin: 10px 0 0;
  background: ${({ theme }) => theme.colors.report.accent};
`;

const Kpis = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 20px;
  background: ${({ theme }) => theme.colors.report.paper};
  border-radius: 0 0 8px 8px;
  padding: 20px 32px;
  margin-bottom: 20px;
  font-family: ${({ theme }) => theme.metrics.font.family};
`;

const Kpi = styled.div`
  border-top: 2px solid ${({ theme }) => theme.colors.report.brand};
  padding-top: 10px;
`;

const KpiLabel = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.colors.report.muted};
`;

const KpiValue = styled.div`
  margin-top: 6px;
  font-size: 22px;
  font-weight: 800;
  color: ${({ theme }) => theme.colors.report.brand};
`;

const KpiSub = styled.div`
  margin-top: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.report.muted};
`;

export default function ReportHeader({ data, organization, t, lang }) {
  const counts = data.survey.questionCounts || {};
  const total = (counts.scored || 0) + (counts.freeText || 0) + (counts.breakdown || 0) + (counts.other || 0);
  const invited = data.participation.invited;
  return (
    <div data-testid="report-header">
      <Band>
        <TopRow>
          <span>{organization?.name}</span>
          <Pill>{t('survey.report.confidential')}</Pill>
        </TopRow>
        <Title>{data.survey.title}</Title>
        <div>{t('survey.report.coverSuffix')}</div>
        <Accent />
      </Band>
      <Kpis>
        <Kpi>
          <KpiLabel>{t('survey.report.respondents')}</KpiLabel>
          <KpiValue>{t('survey.report.respondentsValue', { count: data.participation.responded })}</KpiValue>
        </Kpi>
        <Kpi>
          <KpiLabel>{invited != null ? t('survey.report.participationRate') : t('survey.report.kpiResponses')}</KpiLabel>
          <KpiValue>{invited != null ? formatPct(t, data.participation.ratePct) : data.participation.responded}</KpiValue>
        </Kpi>
        <Kpi>
          <KpiLabel>{t('survey.report.period')}</KpiLabel>
          <KpiValue style={{ fontSize: 15 }}>{periodText(data, lang)}</KpiValue>
        </Kpi>
        <Kpi>
          <KpiLabel>{t('survey.report.surveyStructure')}</KpiLabel>
          <KpiValue>{t('survey.report.questionsValue', { count: total })}</KpiValue>
          <KpiSub>{t('survey.report.structureDetail', { scored: counts.scored || 0, freeText: counts.freeText || 0, breakdown: counts.breakdown || 0 })}</KpiSub>
        </Kpi>
      </Kpis>
    </div>
  );
}
